import Swiper, { Navigation } from "swiper";

Swiper.use([Navigation,]);

document.addEventListener("DOMContentLoaded", () => {

	var swiper = new Swiper(".carouselSwiper", {
	    slidesPerView: 1,
	    spaceBetween: 24,

	    navigation: {
	      nextEl: ".swiper-button-next",
	      prevEl: ".swiper-button-prev",
	    },

	    breakpoints: {
	      640: {
	        slidesPerView: 2,
	        spaceBetween: 24,
	      },
	      768: {
	        slidesPerView: 2,
	        spaceBetween: 40,
	      },
	      1024: {
	        slidesPerView: 2,
	        spaceBetween: 48,
	      },
	      1280: {
	        slidesPerView: 2,
	        spaceBetween: 70,
	      },
	    },
  	});

});